import * as React from "react";
import {
  IPeerGroupsProps,
  IFilter,
  getPeerGroupData,
  IPeerGroupTabsProps,
} from "../../lib/http";
import * as ReactHighcharts from "react-highcharts";
import { Panel, Row, Col } from "react-bootstrap";
import PanelGraph from "app/components/tabs/PanelGraph";

interface IAssetAllocationByStyleState {
  title: string;
  loading: boolean;
  filters: IFilter;
  Strat_T_V12_PortStratText1: string;
  Strat_N_V12_StratAppPct: number;
  Strat_N_V12_StratAppPctAvg: number;
  Strat_N_V12_StratInvOthPct: number;
  Strat_N_V12_StratInvOthPctAvg: number;
  Strat_N_V12_StratBalPct: number;
  Strat_N_V12_StratBalPctAvg: number;
  Strat_N_V12_StratPresPct: number;
  Strat_N_V12_StratPresPctAvg: number;
  Strat_T_V12_AppLabel: string;
  Strat_T_V12_AppAvgLabel: string;
  Strat_T_V12_InvOthLabel: string;
  Strat_T_V12_InvOthAvgLabel: string;
  Strat_T_V12_BalLabel: string;
  Strat_T_V12_BalAvgLabel: string;
  Strat_T_V12_PresLabel: string;
  Strat_T_V12_PresAvgLabel: string;
  data: any[];
}

export class AssetAllocationByStyle extends React.Component<
  IPeerGroupTabsProps,
  IAssetAllocationByStyleState
  > {
  state: IAssetAllocationByStyleState = {
    title: "",
    loading: false,
    Strat_T_V12_PortStratText1: "",
    Strat_N_V12_StratAppPct: 0,
    Strat_N_V12_StratAppPctAvg: 0,
    Strat_N_V12_StratInvOthPct: 0,
    Strat_N_V12_StratInvOthPctAvg: 0,
    Strat_N_V12_StratBalPct: 0,
    Strat_N_V12_StratBalPctAvg: 0,
    Strat_N_V12_StratPresPct: 0,
    Strat_N_V12_StratPresPctAvg: 0,
    Strat_T_V12_AppLabel: "",
    Strat_T_V12_AppAvgLabel: "",
    Strat_T_V12_InvOthLabel: "",
    Strat_T_V12_InvOthAvgLabel: "",
    Strat_T_V12_BalLabel: "",
    Strat_T_V12_BalAvgLabel: "",
    Strat_T_V12_PresLabel: "",
    Strat_T_V12_PresAvgLabel: "",
    filters: { assetLevel: 0 },
    data: [],
  };

  public round(numberToRound: number, precision: number) {
    return parseFloat((Math.round(numberToRound * 10) / 10).toFixed(precision));
  }

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state;

    if (!data || data.length == 0) {
      return;
    }

    const currentSet = data.find(
      (dataPoint) => dataPoint.filterId === filters.assetLevel
    );

    this.setState({
      Strat_N_V12_StratAppPct: this.round(
        currentSet.Strat_N_V12_StratAppPct * 100.0,
        1
      ),
      Strat_N_V12_StratAppPctAvg: this.round(
        currentSet.Strat_N_V12_StratAppPctAvg * 100.0,
        1
      ),
      Strat_N_V12_StratInvOthPct: this.round(
        currentSet.Strat_N_V12_StratInvOthPct * 100.0,
        1
      ),
      Strat_N_V12_StratInvOthPctAvg: this.round(
        currentSet.Strat_N_V12_StratInvOthPctAvg * 100.0,
        1
      ),
      Strat_N_V12_StratBalPct: this.round(
        currentSet.Strat_N_V12_StratBalPct * 100.0,
        1
      ),
      Strat_N_V12_StratBalPctAvg: this.round(
        currentSet.Strat_N_V12_StratBalPctAvg * 100.0,
        1
      ),
      Strat_N_V12_StratPresPct: this.round(
        currentSet.Strat_N_V12_StratPresPct * 100.0,
        1
      ),
      Strat_N_V12_StratPresPctAvg: this.round(
        currentSet.Strat_N_V12_StratPresPctAvg * 100.0,
        1
      ),
      Strat_T_V12_AppLabel: currentSet.Strat_T_V12_AppLabel,
      Strat_T_V12_AppAvgLabel: currentSet.Strat_T_V12_AppAvgLabel,
      Strat_T_V12_InvOthLabel: currentSet.Strat_T_V12_InvOthLabel,
      Strat_T_V12_InvOthAvgLabel: currentSet.Strat_T_V12_InvOthAvgLabel,
      Strat_T_V12_BalLabel: currentSet.Strat_T_V12_BalLabel,
      Strat_T_V12_BalAvgLabel: currentSet.Strat_T_V12_BalAvgLabel,
      Strat_T_V12_PresLabel: currentSet.Strat_T_V12_PresLabel,
      Strat_T_V12_PresAvgLabel: currentSet.Strat_T_V12_PresAvgLabel,
      loading: false,
    });
  }

  getSeries() {
    const {
      Strat_N_V12_StratAppPct,
      Strat_N_V12_StratAppPctAvg,
      Strat_N_V12_StratInvOthPct,
      Strat_N_V12_StratInvOthPctAvg,
      Strat_N_V12_StratBalPct,
      Strat_N_V12_StratBalPctAvg,
      Strat_N_V12_StratPresPct,
      Strat_N_V12_StratPresPctAvg,
      Strat_T_V12_AppLabel,
      Strat_T_V12_AppAvgLabel,
      Strat_T_V12_InvOthLabel,
      Strat_T_V12_InvOthAvgLabel,
      Strat_T_V12_BalLabel,
      Strat_T_V12_BalAvgLabel,
      Strat_T_V12_PresLabel,
      Strat_T_V12_PresAvgLabel,
    } = this.state;

    const series = [
      {
        name: "Values",
        data: [
          {
            y: Strat_N_V12_StratAppPct,
            name: Strat_T_V12_AppLabel,
            color: "#A9D08E",
            borderColor: '#a1a1a1',
          },
          {
            y: Strat_N_V12_StratBalPct,
            name: Strat_T_V12_BalLabel,
            color: "#BDD7EE",
            borderColor: '#a1a1a1',
          },
          {
            y: Strat_N_V12_StratInvOthPct,
            name: Strat_T_V12_InvOthLabel,
            color: "#8EA9DB",
            borderColor: '#a1a1a1',
          },
          {
            y: Strat_N_V12_StratPresPct,
            name: Strat_T_V12_PresLabel,
            color: "#D9D9D9",
            borderColor: '#a1a1a1',
          },
        ],
      },
      {
        name: "Averages",
        data: [
          {
            y: Strat_N_V12_StratAppPctAvg,
            name: Strat_T_V12_AppAvgLabel,
            color: "#a1a1a1",
            borderColor: '#a1a1a1',
          },
          {
            y: Strat_N_V12_StratBalPctAvg,
            name: Strat_T_V12_BalAvgLabel,
            color: "#a1a1a1",
            borderColor: '#a1a1a1',
          },
          {
            y: Strat_N_V12_StratInvOthPctAvg,
            name: Strat_T_V12_InvOthAvgLabel,
            color: "#a1a1a1",
            borderColor: '#a1a1a1',
          },
          {
            y: Strat_N_V12_StratPresPctAvg,
            name: Strat_T_V12_PresAvgLabel,
            color: "#a1a1a1",
            borderColor: '#a1a1a1',
          },
        ],
      },
    ];

    return series;
  }

  static getChartConfig(series) {
    return {
      chart: {
        type: "bar",
      },
      title: {
        text: "",
      },
      plotOptions: {
        series: {
          dataLabels: {
            enabled: true,
            inside: true,
            format: "{point.name}",
            style: {
              textOutline: false,
            },
          },
        },
      },
      legend: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
      yAxis: {
        title: "",
        visible: false,
      },
      xAxis: {
        categories: ["Appreciation", "Balanced", "Inv-Oth", "Preservation"],
      },
      series,
    };
  }

  render() {
    const { loading } = this.state;
    const series = this.getSeries();

    return (
      <PanelGraph
        title=""
        loading={loading}
        chartConfig={AssetAllocationByStyle.getChartConfig(series)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/AssetAllocation/AssetAllocationByStyle/index.tsx